export default __webpack_public_path__ + "static/media/second-right-img@1x.1aef18ad.webp";